import { useCommonStyles } from '@/common/theme/css';
import { Stack, Tooltip, UnstyledButton } from '@mantine/core';
import { IconEdit, IconFolderOpen } from '@tabler/icons-react';
import { Link, useLocation } from 'react-router-dom';
import { useMantineTheme } from '@mantine/core';
import { useTranslation } from 'react-i18next';

const Sidebar = () => {
    const { t } = useTranslation();
    const { classes } = useCommonStyles();
    const location = useLocation();
    const theme = useMantineTheme();

    return (
        <Stack p={16} gap={12} style={{ height: '100%' }} align="center">
            {/* 플래너 메뉴 */}
            <Tooltip label={t('feature.planner')} position="bottom" withArrow>
                <UnstyledButton
                    component={Link}
                    to="/planner"
                    p={8}
                    display="flex"
                    className={classes.mainSidebarItem}
                    {...(location.pathname === '/planner'
                        ? { 'data-active': true }
                        : {})}
                >
                    <IconEdit
                        size={24}
                        color={
                            location.pathname === '/planner'
                                ? theme.colors.gray[8]
                                : theme.colors.gray[6]
                        }
                    />
                </UnstyledButton>
            </Tooltip>

            {/* 드라이브 메뉴 */}
            <Tooltip label={t('feature.drive')} position="bottom" withArrow>
                <UnstyledButton
                    component={Link}
                    to="/drive"
                    p={8}
                    display="flex"
                    className={classes.mainSidebarItem}
                    {...(location.pathname === '/drive'
                        ? { 'data-active': true }
                        : {})}
                >
                    <IconFolderOpen
                        size={24}
                        color={
                            location.pathname === '/drive'
                                ? theme.colors.gray[8]
                                : theme.colors.gray[6]
                        }
                    />
                </UnstyledButton>
            </Tooltip>
        </Stack>
    );
};

export default Sidebar;
